import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { EMAIL_REGEX, PHONE_REGEX } from '../../../../utils/validations';
import { guestLogin } from '../../../../app/store/slices/auth/authSlice';

export default function useHandleGuestLogin() {
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values) => {
            try {
                await dispatch(
                    guestLogin({ email: values.guestEmail, phone: values.guestPhone })
                ).unwrap();
            } catch (error) {
                console.error('Error during guest login:', error);
            }
        }
    });

    return { formik };
}

const initialValues = {
    guestEmail: '',
    guestPhone: ''
};

const validationSchema = Yup.object({
    guestEmail: Yup.string()
        .required('Email is required')
        .matches(EMAIL_REGEX, 'Invalid email format'),
    guestPhone: Yup.string()
        .required('Phone number is required')
        .matches(PHONE_REGEX, 'Invalid phone number format')
});
